// extracted by extract-css-chunks-webpack-plugin
module.exports = {"aligned":"ZyRYPv","grid":"_1ROb9e","centered-section-spacing":"pkdihK","grid-odd":"mnE9NY","newsArticlesContainer":"_18G2kp","blackLink":"-u3LdP"};